import { createEntityAdapter, EntityId, EntityState } from "@reduxjs/toolkit";
import { UserPlayMode } from "features/playback/types/UserPlayMode";
import { ObjectDetectionModelName } from "types/ObjectDetectionModelName";
import { PersistedRecording } from "types/PersistedRecording";
import { ObjectDetectionFrame } from "types/reId/ObjectDetectionFrame";
import { ObjectDetectionModel } from "types/reId/ObjectDetectionModel";
import { ReIdentificationModelSelectionDossierCapabilitySetting } from "types/reId/ReIdentificationModelSelectionDossierCapabilitySetting";
import { VectorSearchResultRecord } from "types/reId/VectorSearchResultRecord";

export const persistedRecordingAdapter =
    createEntityAdapter<PersistedRecording>({
        sortComparer: (a, b) =>
            a.persistedStartTime.localeCompare(b.persistedStartTime),
    });

export interface ReIdState {
    reIdViewModeIsActive: boolean;
    savedUserPlaybackMode: UserPlayMode | undefined;

    // ReId
    detectedObjects: ObjectDetectionFrame[];
    selectedDetectedObjectFrame?: ObjectDetectionFrame;
    activeDossierDeviceId?: EntityId;
    activePersistedRecordingId?: EntityId;
    objectDetectionModels: ObjectDetectionModel[];
    reIdentificationModelSelectionDossierCapabilitySetting?: ReIdentificationModelSelectionDossierCapabilitySetting;
    selectedObjectDetectionModelName?: ObjectDetectionModelName;

    activeDetectedObjectPersistedRecordings: EntityState<
        PersistedRecording,
        EntityId
    >;
    activeVectorSearchResultRecordToPlay?: VectorSearchResultRecord;
    vectorSearchResults: VectorSearchResultRecord[];
    loadingVectorSearchResults: boolean;
}

export const initialState: ReIdState = {
    reIdViewModeIsActive: false,
    savedUserPlaybackMode: undefined,
    detectedObjects: [],
    selectedDetectedObjectFrame: undefined,
    objectDetectionModels: [],
    reIdentificationModelSelectionDossierCapabilitySetting: undefined,
    selectedObjectDetectionModelName: undefined,
    activeDetectedObjectPersistedRecordings:
        persistedRecordingAdapter.getInitialState(),
    activeVectorSearchResultRecordToPlay: undefined,
    activeDossierDeviceId: undefined,
    activePersistedRecordingId: undefined,
    vectorSearchResults: [],
    loadingVectorSearchResults: false,
};
